module.exports = __webpack_public_path__ + "static/media/lb.4b3ea673.svg";